import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import {
  Info, InfoContainerBase, InfoIconBase, InfoIconContainerBase,
} from '.';

const DefaultContainer = styled(InfoContainerBase)`${({ theme }) => `
    background: ${theme.colours.success[2]};
`}`;

const DefaultIconContainer = styled(InfoIconContainerBase)`${({ theme }) => `
    background: ${theme.colours.success[1]};
`}`;

const DefaultIcon = styled(InfoIconBase).attrs(() => ({
  className: 'mi-check',
}))`${({ theme }) => `
    color: ${theme.colours.neutral[10]};
`}`;

export function SuccessInfo({ children }: PropsWithChildren) {
  return (
    <Info
      Container={DefaultContainer}
      IconContainer={DefaultIconContainer}
      icon={<DefaultIcon />}
    >
      {children}
    </Info>
  );
}
